import { LoaderFunction } from "@remix-run/router";

export const composeLoaders =
  (...loaders: LoaderFunction[] | LoaderFunction[][]): LoaderFunction =>
  (args) =>
    Promise.all(
      loaders.flat().map((loader) => loader(args) as Promise<unknown>),
    );
